import React, { createContext, useCallback, useContext, useState } from 'react';
import { GlobalState } from '../types/stateProviders/GlobalState';

const GlobalStateContext = createContext<any | null>(null);
const GlobalDispatchContext = createContext<
	(newState: Partial<GlobalState>) => void
>(() => {});

export const GlobalStateProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const initialGlobalState: GlobalState = {
		modalOpen: false,
		modalContent: null,
		appUser: null,
		hamburgerOpen: false,
		quotations: null,
		company: null,
		isSuperAdmin: false,
		sidebarCollapsed: false,
		canvasFullscreen: false,
	};

	const [globalState, setGlobalState] =
		useState<GlobalState>(initialGlobalState);
	const updateGlobalState = useCallback(
		(newGlobalState: Partial<GlobalState>) => {
			setGlobalState((prevState: GlobalState) => {
				return { ...prevState, ...newGlobalState };
			});
		},
		[]
	);

	return (
		<GlobalStateContext.Provider value={globalState}>
			<GlobalDispatchContext.Provider value={updateGlobalState}>
				{children}
			</GlobalDispatchContext.Provider>
		</GlobalStateContext.Provider>
	);
};

export function useGlobalState(): GlobalState {
	return useContext(GlobalStateContext);
}

export function useGlobalDispatch(): React.Dispatch<Partial<GlobalState>> {
	return useContext(GlobalDispatchContext);
}
